import { FC } from 'react'

import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { FullScreenModal } from 'src/Components/FullScreenModal'

import { AdsLanguagesModalContent } from './AdsLanguagesModalContent'

const Container = styled.div<{ $withMargin?: boolean }>`
  display: flex;
  padding-top: ${(props) => (props.$withMargin ? '24px' : '72px')};
  padding-bottom: 80px;
  padding-left: 16px;
  padding-right: 16px;
  flex-direction: column;
  gap: 24px;

  & > *:first-child + * {
    margin-top: ${(props) => (props.$withMargin ? '-24px' : '0')};
    margin-bottom: ${(props) => (props.$withMargin ? '-24px' : '0')};
  }

  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    margin: 0 auto;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 64px;
    width: 600px;
  }
`
export const AdsLanguagesModal: FC = () => {
  const { setSearch } = useCustomSearchParams()

  return (
    <FullScreenModal
      showCloseButton
      fixedCloseButton={false}
      open
      closable
      prefixCls='languages'
      onCancel={() => setSearch({ modal: null })}
    >
      <Container $withMargin>
        <AdsLanguagesModalContent onClose={() => setSearch({ modal: null })} />
      </Container>
    </FullScreenModal>
  )
}
